<template>
  <div>
    <v-container grid-list-xl fluid>
      <div v-if="alerta">
        <alert-empty></alert-empty>
      </div>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-container>
              <v-layout>
                <v-flex xs12 md4>
                  <v-select
                    v-model="nivelValue"
                    :items="nivelSelect"
                    label="Nivel"
                    data-vv-name="listaNiveles"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="tipoMaterialValue"
                    :items="tipoMaterialSelect"
                    label="Tipo de material"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="tipoPruebaValue"
                    :items="tipoPruebaSelect"
                    label="Tipo de prueba"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete
                    v-model="fechaProgresoValue"
                    label="Fecha Progreso"
                    :items="fechaProgresoSelect"
                  ></v-autocomplete>
                </v-flex>
                <v-btn
                  fab
                  dark
                  color="teal"
                  title="Filtrar contratos"
                  @click="filterProv()"
                >
                  <v-icon dark>filter_list</v-icon>
                </v-btn>
                <v-btn
                  fab
                  dark
                  color="red darken-4"
                  title="Limpiar filtros"
                  @click="clear()"
                >
                  <v-icon dark>clear_all</v-icon>
                </v-btn>
              </v-layout>
              <v-layout class="d-flex pa-2">
                <div class="d-flex pa-2" xs12 sm6>
                  <v-text-field
                    width="300px"
                    v-model="txtBusqueda"
                    placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
                    single-line
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    @click="loadData()"
                    :disabled="txtBusqueda.length < 3"
                    class="shrink"
                    ><v-icon dark left>search</v-icon>Buscar</v-btn
                  >
                  <v-btn
                    color="secondary"
                    @click="clear()"
                    :disabled="txtBusqueda.length < 3"
                    class="shrink"
                    ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
                  >
                </div>
              </v-layout>
            </v-container>
            <!-- TABLA PROVEEDORES -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <grid-documento-diario-progreso
                v-if="!loading"
                :itemsDocumento="itemsDocumento"
              ></grid-documento-diario-progreso>
            </template>
            <!-- TABLA PROVEEDORES -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import GridDocumentoDiarioProgreso from "@/modules/mecanizado/views/progreso/GridDocumentoDiarioProgreso.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "menu-sub-proceso-impresion",
  components: {
    GridDocumentoDiarioProgreso,
    AlertEmpty,
    Loading,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      loading: false,
      proveedor: {},
      areaValue: "",
      tipoDocumentoValue: "",
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      fechaEvolucion: new Date().toISOString().substr(0, 10),
      itemsDocumento: [],
      txtBusqueda: "",
      nivelSelect: [],
      tipoMaterialSelect: [],
      tipoPruebaSelect: [],
      tipoDocumentoValue: [],
      fechaProgresoSelect: [],
      areaSelect: [],
      nivelValue: null,
      tipoMaterialValue: null,
      tipoPruebaValue: null,
      tipoDocumentoSelect: null,
      fechaProgresoValue: null,
      areaValue: null,
      filter: false,
      proceso: "",
      alerta: false,
    };
  },

  mounted() {
    this.loadData();
  },

  created() {},
  methods: {
    async loadDocumentosFilter() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        material:
          this.tipoMaterialValue && this.tipoMaterialValue != null
            ? this.tipoMaterialValue
            : null,
        prueba:
          this.tipoPruebaValue && this.tipoPruebaValue != null
            ? this.tipoPruebaValue
            : null,
        fecha_progreso:
          this.fechaProgresoValue && this.fechaProgresoValue != null
            ? this.fechaProgresoValue.replace(
                /^(\d{2})-(\d{2})-(\d{4})$/g,
                "$3-$2-$1"
              )
            : null,
        idContrato: idContrato,
        subProceso: subProceso,
        txtBusqueda: this.txtBusqueda,
      };

      return await axios
        .post("/progreso/contrato/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    formatoFechaEuropea(f) {
      // Convierte un texto de la forma europea a la forma americana
      return f.replace(/^(\d{2})-(\d{2})-(\d{4})$/g, "$3-$2-$1");
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadDocumentosFilter();
      if (this.itemsDocumento.length > 0) {
        this.loadNivelSelect();
        this.loadMaterialSelect();
        this.loadPruebaSelect();
        this.loadAreaSelect();
        this.loadFechaProgresoSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    loadNivelSelect() {
      let niv = [];
      this.itemsDocumento.forEach(function (d) {
        let index = niv.findIndex((x) => x == d.subItemId.nivel);
        if (index === -1) {
          niv.push(d.subItemId.nivel);
        }
      });
      this.nivelSelect = niv;
    },

    loadMaterialSelect() {
      let mat = [];
      this.itemsDocumento.forEach(function (d) {
        let index = mat.findIndex((x) => x == d.subItemId.tipoMaterial);
        if (index === -1) {
          mat.push(d.subItemId.tipoMaterial);
        }
      });
      this.tipoMaterialSelect = mat;
    },
    loadFechaProgresoSelect() {
      let doc = [];
      this.itemsDocumento.forEach(function (d) {
        let index = doc.findIndex((x) => x == d.fechaProgreso);
        if (index === -1) {
          doc.push(d.fechaProgreso);
        }
      });
      this.fechaProgresoSelect = doc;
    },
    loadPruebaSelect() {
      let pru = [];
      this.itemsDocumento.forEach(function (d) {
        let index = pru.findIndex((x) => x == d.subItemId.tipoPrueba);
        if (index === -1) {
          pru.push(d.subItemId.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = pru;
    },

    loadAreaSelect() {
      let are = [];
      this.itemsDocumento.forEach(function (d) {
        let index = are.findIndex((x) => x == d.subItemId.area);
        if (index === -1) {
          are.push(d.subItemId.area);
        }
      });
      this.areaSelect = are;
    },

    clear() {
      this.nivelValue = "";
      this.tipoMaterialValue = "";
      this.tipoPruebaValue = "";
      this.tipoDocumentoValue = "";
      this.areaValue = "";
      this.fechaProgresoValue = "";
      this.txtBusqueda = "";
      this.loadData();
    },
    filterProv() {
      this.filter = true;
      this.loadData();
    },
  },
};
</script>
